/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import clsx from 'clsx';
import { cloneDeep, groupBy, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import useWidgetAPI from '../../hooks/network/useWidgetAPI';
import { roundOfAndFormate } from '../../utils/Utils';
import WidgetDropdown from './WidgetDropdown';

function TodayDeliveredSchedule({
  isSelectedWidget,
  customerId,
  projectId,
  widgetIndex,
  authToken,
}) {
  const { getDeliveredAndScheduleData } = useWidgetAPI();
  const [data, setData] = useState();
  const [expandSchedule, setExpandSchedule] = useState([]);
  const { widgetDropDownOptions: dropDownOptions } = useContext(AppContext);

  useEffect(() => {
    setExpandSchedule([]);
    fetchWidgetData(customerId, projectId);
  }, [customerId, projectId]);

  const fetchWidgetData = async (customerId, projectId) => {
    const query = { customerId, projectId };
    const response = await getDeliveredAndScheduleData(query);
    const scheduledPO = groupBy(response?.scheduledPO, 'DeliveryDate');
    setData(scheduledPO);
  };

  const handleShowMoreOrLess = (ind) => {
    const index = expandSchedule?.findIndex((f) => f === ind);
    if (index > -1) {
      const expandedCloned = cloneDeep(expandSchedule);
      expandedCloned?.splice(index, 1);
      setExpandSchedule(expandedCloned);
    } else {
      setExpandSchedule([...expandSchedule, ind]);
    }
  };

  const renderWidgetBody = () => {
    return (
      <div className='mt-4 border-t border-solid border-gray-200'>
        <div className='tab-wraaper-tdas'>
          <div className='flex w-full items-start justify-start gap-6 overflow-auto'>
            {!isEmpty(data) &&
              Object.keys(data)?.map((s, si) => (
                <div key={si} className='w-[250px] flex-shrink-0'>
                  <div className='mb-3 mt-2'>
                    <p
                      className={clsx(
                        'text-[10px] font-medium uppercase text-orange-700 break:text-sm',
                      )}
                    >
                      {moment(s)?.format('dddd')}
                    </p>
                    <p className='text-2xl font-semibold'>{moment(s)?.format('DD MMM')}</p>
                  </div>
                  <p className='tdas-schedule-tabpanel text-gray-900'>
                    Tonnage:{' '}
                    <span className='text-[#DA8E32]'>
                      {roundOfAndFormate(
                        (data?.[s]?.reduce((acc, c) => (acc += c?.WeightKg), 0) || 0) / 1000,
                      )}
                    </span>
                  </p>
                  <div className='mt-2'>
                    <p className='tdas-schedule-tabpanel text-gray-900'>
                      PO: <span className='text-[#DA8E32]'>{data?.[s]?.length}</span>
                    </p>
                    <div className='flex w-full flex-col items-start justify-start'>
                      {data?.[s]
                        ?.filter((f, i) => expandSchedule?.includes(si) || i < 5)
                        ?.map((s, poi) => (
                          <li
                            key={`${s?.PONumber}${poi}`}
                            className='tdas-schedule-tabpanel w-full px-5 text-left text-[#DA8E32]'
                          >
                            {s?.PONumber}
                          </li>
                        ))}
                    </div>
                    {data?.[s]?.length > 5 && (
                      <li
                        className='tdas-schedule-tabpanel cursor-pointer list-none !pl-5 text-[#DA8E32]'
                        onClick={() => handleShowMoreOrLess(si)}
                      >
                        {!expandSchedule?.includes(si)
                          ? `+${data?.[s]?.length - 5} More Po`
                          : 'Show less'}
                      </li>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isSelectedWidget && (
        <div className='rounded-tr-lg rounded-tl-lg border border-solid border-gray-200 bg-[#FFF5EA] py-3 px-3 text-sm font-semibold'>
          {dropDownOptions?.find((f) => f?.customerID === customerId)?.customerName}
        </div>
      )}
      <div className={clsx({ 'rounded-br-lg rounded-bl-lg': isSelectedWidget }, 'widget-wrapper')}>
        <div className='flex items-center justify-between'>
          {/* */}
          <div>
            <p className='font-semibold text-black'>Schedule</p>
          </div>
          <div className='m-0 self-start p-0 text-[8px]'>
            <span className=''>
              {isSelectedWidget && (
                <WidgetDropdown
                  scope='TodayDeliveredSchedule'
                  isSelected
                  widgetIndex={widgetIndex}
                />
              )}
            </span>
          </div>
        </div>
        {/* <div className='mt-4 border-t border-solid border-gray-200'>
            <div className='tab-wraaper-tdas'>
              <div className='flex w-full items-start justify-start gap-6 overflow-auto'>
                {data?.scheduledPO &&
                  Object.keys(data?.scheduledPO)?.map((s, si) => (
                    <div key={si} className='w-[250px] flex-shrink-0'>
                      <div className='mb-3 mt-2'>
                        <p
                          className={clsx(
                            'text-[10px] font-medium uppercase text-orange-700 break:text-sm',
                          )}
                        >
                          {moment(s)?.format('dddd')}
                        </p>
                        <p className='text-2xl font-semibold'>{moment(s)?.format('DD MMM')}</p>
                      </div>
                      <p className='tdas-schedule-tabpanel text-gray-900'>
                        Tonnage:{' '}
                        <span className='text-[#DA8E32]'>
                          {roundOfAndFormate(data?.scheduledPO?.[s]?.totalTonnage)}
                        </span>
                      </p>
                      <div className='mt-2'>
                        <p className='tdas-schedule-tabpanel text-gray-900'>
                          PO:{' '}
                          <span className='text-[#DA8E32]'>
                            {data?.scheduledPO?.[s]?.po?.length}
                          </span>
                        </p>
                        {data?.scheduledPO?.[s]?.po
                          ?.filter((f, i) => expandSchedule?.includes(si) || i < 5)
                          ?.map((s, poi) => (
                            <li
                              key={`${s?.PONumber}${poi}`}
                              className='tdas-schedule-tabpanel px-5 text-[#DA8E32]'
                            >
                              {s}
                            </li>
                          ))}
                        {data?.scheduledPO?.[s]?.po?.length > 5 && (
                          <li
                            className='tdas-schedule-tabpanel cursor-pointer list-none !pl-5 text-[#DA8E32]'
                            onClick={() => handleShowMoreOrLess(si)}
                          >
                            {!expandSchedule?.includes(si)
                              ? `+${data?.scheduledPO?.[s]?.po?.length - 5} More Po`
                              : 'Show less'}
                          </li>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div> */}

        {authToken ? (
          <form action='https://prodash.natsteel.com.sg:8080/v1/auth/ump' method='post'>
            <input type='hidden' name='token' value={authToken} />
            <input type='hidden' name='path' value={'/calendar'} />
            <button className='w-full'>{renderWidgetBody()}</button>
          </form>
        ) : (
          renderWidgetBody()
        )}
      </div>
    </div>
  );
}

export default TodayDeliveredSchedule;
